/* Athleia product extras: places rating / fit / delivery promise into the product info, pincode estimate, Complete the look */
(function () {
  var root = document.querySelector('[data-apx]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var info = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product__info-container');
  function slot(name) { var s = root.querySelector('[data-apx-slot="' + name + '"]'); return s && s.children.length ? s : null; }
  function after(ref, el) { if (ref && el) { ref.insertAdjacentElement('afterend', el); return true; } return false; }

  if (info) {
    var rating = slot('rating'), fit = slot('fit'), trust = slot('trust');
    var title = info.querySelector('.product__title');
    var picker = info.querySelector('variant-selects, variant-radios');
    var form = info.querySelector('product-form');
    var formBlock = form ? (form.closest('[id^="shopify-block"], .product-form__buttons') || form) : null;
    if (rating) { if (!after(title, rating)) info.prepend(rating); }
    if (fit) { if (!after(picker, fit)) { if (formBlock) formBlock.insertAdjacentElement('beforebegin', fit); else info.appendChild(fit); } }
    if (trust) { if (!after(form, trust)) info.appendChild(trust); }
  }
  root.remove();

  // Reviews link scrolls to the reviews widget
  document.querySelectorAll('[data-apx-reviews]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews, .jdgm-rev-widg, [id*="judgeme"]');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); }
    });
  });

  // ---------- Pincode delivery estimate ----------
  var pinForm = document.querySelector('[data-apx-pin]');
  if (pinForm) {
    var input = pinForm.querySelector('input'), out = pinForm.querySelector('.apx-pin__out');
    var zones = (root.dataset.zones || '').split(';').map(function (z) {
      var p = z.split('|'), d = (p[1] || '3-6').split('-');
      return { prefixes: p[0] === '*' ? ['*'] : p[0].split(',').map(function (x) { return x.trim(); }).filter(Boolean), min: parseInt(d[0], 10) || 3, max: parseInt(d[1] || d[0], 10) || 6 };
    });
    var dispatch = parseInt(root.dataset.shipDays, 10) || 0, cutoff = parseInt(root.dataset.cutoff, 10) || 14;
    function addBusinessDays(date, n) { var d = new Date(date); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; }
    function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
    function zoneFor(pin) {
      var best = null, bestLen = -1;
      zones.forEach(function (z) { z.prefixes.forEach(function (p) { if ((p === '*' && bestLen < 0) || (p !== '*' && pin.indexOf(p) === 0 && p.length > bestLen)) { best = z; bestLen = p === '*' ? 0 : p.length; } }); });
      return best;
    }
    function check(pin) {
      out.classList.remove('is-error');
      if (!/^[1-8]\d{5}$/.test(pin)) { out.classList.add('is-error'); out.textContent = 'Please enter a valid 6-digit pincode.'; return; }
      var z = zoneFor(pin) || { min: 3, max: 6 };
      var now = new Date(), start = new Date(now);
      var d = dispatch + (now.getHours() >= cutoff ? 1 : 0);
      var shipDay = addBusinessDays(start, d);
      var from = addBusinessDays(shipDay, z.min), to = addBusinessDays(shipDay, z.max);
      out.innerHTML = '';
      var line = document.createElement('span'); line.textContent = 'Delivery to ' + pin + ' by ' + (z.min === z.max ? fmt(from) : fmt(from) + ' – ' + fmt(to));
      var note = document.createElement('small'); note.textContent = 'Free delivery. Estimated date, may vary slightly by courier.';
      out.appendChild(line); out.appendChild(note);
      try { localStorage.setItem('athleia_pincode', pin); } catch (e) {}
    }
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
    pinForm.addEventListener('submit', function (e) { e.preventDefault(); check(input.value.trim()); });
    try { var saved = localStorage.getItem('athleia_pincode'); if (saved) { input.value = saved; check(saved); } } catch (e) {}
  }

  // ---------- Complete the look ----------
  var ctl = document.querySelector('[data-apx-ctl]');
  if (ctl) {
    var main = document.querySelector('[id^="MainProduct-"]');
    var mainSection = main && main.closest('.shopify-section');
    if (mainSection) mainSection.insertAdjacentElement('afterend', ctl);

    ctl.querySelectorAll('[data-apx-card]').forEach(function (card) {
      var variants = []; try { variants = JSON.parse(card.querySelector('[data-variants]').textContent); } catch (e) {}
      var fields = Array.prototype.slice.call(card.querySelectorAll('[data-apx-opt]'));
      var btn = card.querySelector('[data-apx-add]'), msg = card.querySelector('[data-apx-msg]');
      var priceEl = card.querySelector('[data-apx-price]'), img = card.querySelector('.apx-card__img img');
      var single = btn.dataset.single;

      function selected() { return fields.map(function (f) { var on = f.querySelector('[aria-pressed="true"]'); return on ? on.dataset.val : null; }); }
      function match(sel) { return variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); }); }
      function refresh() {
        var sel = selected();
        // grey out values with no available variant given the other choices
        fields.forEach(function (f, i) {
          f.querySelectorAll('.apx-pill').forEach(function (b) {
            var trial = sel;
            var ok = variants.some(function (v) { return v.available && v.options[i] === b.dataset.val && v.options.every(function (o, j) { return j === i || trial[j] == null || o === trial[j]; }); });
            b.disabled = !ok; if (!ok && b.getAttribute('aria-pressed') === 'true' && f.querySelectorAll('.apx-pill').length > 1) b.setAttribute('aria-pressed', 'false');
          });
        });
        sel = selected();
        var v = sel.every(function (s) { return s != null; }) ? match(sel) : null;
        if (v) {
          priceEl.innerHTML = v.price + (v.compare ? '<s>' + v.compare + '</s>' : '');
          if (v.image && img) { img.removeAttribute('srcset'); img.src = v.image; }
          btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out'; btn.dataset.id = v.id;
        } else { btn.disabled = true; btn.textContent = 'Select size'; delete btn.dataset.id; }
      }
      fields.forEach(function (f) {
        f.addEventListener('click', function (e) {
          var b = e.target.closest('.apx-pill'); if (!b || b.disabled) return;
          f.querySelectorAll('.apx-pill').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
          refresh();
        });
      });
      if (!single) refresh();

      btn.addEventListener('click', function () {
        var id = single || btn.dataset.id; if (!id) return;
        var label = btn.textContent;
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: [{ id: Number(id), quantity: 1 }] };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        btn.disabled = true; btn.textContent = 'Adding…';
        var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message || 'Could not add to bag');
            var lines = res.items || [res];
            if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'athleia-ctl', productVariantId: id, cartData: res }); } catch (e) {} }
            if (cart && typeof cart.renderContents === 'function' && res.sections) { cart.classList.remove('is-empty'); cart.renderContents({ key: lines[lines.length - 1].key, sections: res.sections }); }
            else if (!cart) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
            btn.textContent = 'Added ✓'; if (msg) msg.textContent = 'Added to your bag.';
            setTimeout(function () { btn.disabled = false; btn.textContent = label === 'Adding…' ? 'Add to bag' : label; }, 2200);
          })
          .catch(function (err) { btn.disabled = false; btn.textContent = label; if (msg) { msg.textContent = err.message; msg.classList.add('is-error'); } });
      });
    });
  }
})();
